import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { EditorField } from 'libs/forms/views/fieldTypes/editor';

// FIXME: Remove this import for passing the color to Label (Label component should manage its styles by a type prop)
import ThemeColors from 'styles/themes/wikifactory/styles/colors';

import {
  SubPageWrapper,
  SubPageTitle,
  SubPageInfo,
  SubPageDescription,
  SubPageDivider,
  Label,
  Divider,
  Div,
} from 'legacyComponents/styled/lib';
import { Date } from 'apps/components/date';
import { Username } from 'apps/components/shared';
import { Comments } from 'apps/comments/main/index';
import {
  TitleInput,
  MsgInput,
  Edit,
  DeleteBtn,
} from 'apps/aggregator/views/postPageContent';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
@inject('issueTrackerManager')
@observer
export class IssuePageContent extends React.Component {
  componentWillUnmount = () => {
    const {
      issueTrackerManager: { issuePage },
    } = this.props;
    if (issuePage?.editing) {
      issuePage.Cancel();
    }
  };

  render() {
    const { issueTrackerManager } = this.props;

    const { issuePage: issue } = issueTrackerManager;
    const Info = (
      <div>
        {issue?.status === 'Open' ? (
          <Label
            data-testid='projectPage-taskStatus-open'
            backgroundColor={ThemeColors.wfBlue}
            fixed
          >
            <Trans>OPEN</Trans>
          </Label>
        ) : (
          <Label
            data-testid='projectPage-taskStatus-close'
            backgroundColor={ThemeColors.wfOrange}
            fixed
          >
            <Trans>CLOSED</Trans>
          </Label>
        )}
        <SubPageInfo>
          <Trans>Issue opened by</Trans>{' '}
          <Username
            name='profile'
            params={{ profile: issue?.creatorProfile.username }}
          >
            {issue?.creatorProfile.username}
          </Username>
          {' | '}
          <Date value={issue?.dateCreated} />
          {issue?.canUpdate ? (
            issue?.editing ? (
              <span>
                {' | '}
                <DeleteBtn onClick={issueTrackerManager.Cancel}>
                  <Trans>Cancel</Trans>
                </DeleteBtn>
                {' | '}
                <Edit
                  data-testid='projectPage-saveTask-button'
                  onClick={issueTrackerManager.Save}
                >
                  <Trans>Save</Trans>
                </Edit>
              </span>
            ) : (
              <span>
                <span>
                  {' | '}
                  <Edit
                    data-testid='projectPage-editTask-button'
                    onClick={issueTrackerManager.EditIssue}
                  >
                    <Trans>Edit</Trans>
                  </Edit>
                </span>
              </span>
            )
          ) : (
            ''
          )}
        </SubPageInfo>
      </div>
    );

    if (issue?.editing) {
      return (
        <SubPageWrapper>
          <Div position='relative'>
            <TextField
              fieldStore={issue?.form.fieldStores.get('title')}
              editComponent={TitleInput}
              validationPosition={{ top: '10px', right: '5px' }}
            />
          </Div>
          <Divider width='100%' margin='10px auto 10px auto' />
          {Info}
          <SubPageDescription>
            <Div position='relative'>
              <EditorField
                fieldStore={issue?.form.fieldStores.get('description')}
                editComponent={MsgInput}
                paragraphSpacing='paragraphSpacing12'
                validationPosition={{ top: '10px', right: '5px' }}
                blueBorder
                noFormattingHint
                dataTestId='projectPage-editTaskDescription-input'
              />
            </Div>
            <SubPageDivider />
          </SubPageDescription>
          <Comments content={issue} contentType='issue' />
        </SubPageWrapper>
      );
    }
    const store = new EditorStore({
      initialValue: html.deserialize(issue?.description || '<p></p>'),
      formatting: 'basic',
    });
    return (
      <SubPageWrapper>
        <SubPageTitle data-testid='projectPage-task-title'>
          {issue?.title}
        </SubPageTitle>
        {Info}
        {issue?.description !== '<p></p>' ? (
          <SubPageDescription data-testid='projectPage-task-description'>
            <Editor store={store} paragraphSpacing='paragraphSpacing12' />
            <SubPageDivider />
          </SubPageDescription>
        ) : (
          <SubPageDescription empty>
            <i>
              <Trans>No description provided</Trans>.
            </i>
          </SubPageDescription>
        )}
        <Comments
          content={issue}
          contentType='issue'
          dataTestId='projectPage-comments-wrapper'
        />
      </SubPageWrapper>
    );
  }
}

IssuePageContent.propTypes = {
  issueTrackerManager: PropTypes.object,
  t: PropTypes.func,
};
